import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import OldRiskAssessment from "../components/OldRiskAssessment";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const OldRiskAssessmentContainer = connect(mapStateToProps, mapDispatchToProps)(OldRiskAssessment);

export default OldRiskAssessmentContainer;


// WEBPACK FOOTER //
// ./src/containers/OldRiskAssessmentContainer.js